import React, { FC } from 'react';
import { useTranslation } from '@blocs.i18n';
import { RecipientDetailView as RecipientDetailViewBloc } from '@blocs.package-presentation';
import { AppType } from '@blocs.common';
import appConfig from 'config/appConfig';

const RecipientDetailView: FC = () => {
  const { t } = useTranslation();

  return (
    <RecipientDetailViewBloc
      appType={AppType.Reps}
      cdnRoot={appConfig.cdnRoot}
      companyName={t('common:logo.text')}
      presentationTypeName={t('common:label.package')}
      iconName="package-cd"
    />
  );
};

export default RecipientDetailView;
